module.exports = __webpack_public_path__ + "img/8S.8cbf053a.png";